import IBean from './IBean'

export default class CommonBean extends IBean {
    constructor(value) {
        super()
        this.value = value
    }
}
